import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { PRACTICE_SERVICE_DISABLE_CONTROLER_URL } from "api/Service";

export const useTogglePracticeService = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ id, disabled }: { id: number; disabled: boolean }) => {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.post(
        `${tenantVal}${PRACTICE_SERVICE_DISABLE_CONTROLER_URL}`,
        { id, disabled: !disabled }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["practiceServicesAll"] });
    },
  });
};
